import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import Utils from 'Utils'
import Matrix from '../../scripts/Matrix'
import { PeopleAltRounded } from '@material-ui/icons';
import CallIcon from '@material-ui/icons/Call'
import VideocamIcon from '@material-ui/icons/Videocam'
import ChatBubbleIcon from '@material-ui/icons/ChatBubble'
import LockIcon from '@material-ui/icons/Lock'





class RoomListItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      room: props.room,
      consult: props.room.consult,
      clientData: props.clientData,
      isGroup: false,
      mainMember: null,
      title: '',
      redirect: ''
    }
  }

  componentDidMount() {
    const roomData = Utils.initRoomNameAndMember(this.state.room, Matrix.getUserId())
    this.setState({ ...roomData })

    // console.log(this.state.isGroup, this.state.mainMember)

  }

  componentDidUpdate(prevProps) {
    const { consult } = this.props
    let statei = {}

    if (!prevProps.consult && consult) {
      statei = { ...statei, consult }

      if (consult && consult.doctor && consult.doctor.expUnis && consult.doctor.expUnis.length > 0)
        statei = { ...statei, exp: consult.doctor.expUnis[0].expertise.name }

      if (consult && consult.doctor && consult.doctor.spUnis && consult.doctor.spUnis.length > 0)
        statei = { ...statei, spl: consult.doctor.spUnis[0].specialty.name }

      this.setState({ ...statei })
    }

  }

  renderTypeIcon = () => {
    const { type } = this.state.consult

    if (type === 'text') return <ChatBubbleIcon />
    if (type === 'voice') return <CallIcon />
    if (type === 'video') return <VideocamIcon />
  }

  linkToDoctorProfile = e => {
    e.preventDefault()
    this.setState({ redirect: `/doctors/${this.state.consult.doctorId}` })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />
    }
    return (
      <Link to={{
        pathname: `/chat/${this.state.room.roomId}`,
        title: this.state.room.name,
        client: this.state.clientData.client,
        userId: this.state.clientData.userId,
        room_id: this.state.room.roomId,
        accessToken: this.state.clientData.accessToken,
        nextSyncToken: this.state.clientData.nextSyncToken
      }} className="container">
        <div className="rooms-image" onClick={this.linkToDoctorProfile}>
          {!this.state.isGroup && this.state.mainMember &&
            // console.log(this.state.mainMember)
            <img src={this.state.mainMember.getAvatarUrl('https://msg.tebinja.com')} />

          }
          {(this.state.isGroup || !this.state.mainMember) &&
            <img src="/images/person.svg" />

          }
          {/* <img src="/images/person.svg" /> */}
          {/* <PeopleAltRounded ></PeopleAltRounded> */}

        </div>
        <div className="rooms-detail">
          <div className="rooms-name-date">

            <div className="rooms-name">
              {this.state.consult && this.renderTypeIcon()}
              <p>
                {this.state.title}
              </p>
            </div>
            <div className="rooms-date">
              {this.state.consult && this.state.consult.status === 'closed' && <LockIcon style={{ fontSize: 16, marginLeft: 5 }} />}
              <span >
                {this.state.room.timeline.length > 0 ?
                  Utils.getJalaiData(new Date) === Utils.getJalaiData(this.state.room.timeline[this.state.room.timeline.length - 1].event.origin_server_ts) ?
                    Utils.timeStampToHHMM(this.state.room.timeline[this.state.room.timeline.length - 1].event.origin_server_ts) :
                    Utils.getJalaiData(this.state.room.timeline[this.state.room.timeline.length - 1].event.origin_server_ts) :
                  null
                }
              </span>
            </div>
          </div>
          <div style={{ fontWeight: 600, fontSize: 10, color: '#1dc37e', lineHeight: '20px', maxHeight: '20px', overflow: "hidden" }}>
            {!this.state.exp && this.state.spl && 'تخصص ' + this.state.spl}
            {this.state.exp && this.state.exp && 'فوق تخصص ' + this.state.exp}
          </div>
          <div className="rooms-last-content">
            <div style={{ flexGrow: 1 }}>
              {
                this.state.room.timeline.length > 0 && this.state.room.timeline[this.state.room.timeline.length - 1].event.type == 'm.room.message' ?
                  <p className='rtl' style={{ lineHeight: '20px', maxHeight: '20px', overflow: 'hidden' }}>
                    {this.state.room.timeline[this.state.room.timeline.length - 1].event.content.msgtype === 'm.image' && 'عکس'}
                    {this.state.room.timeline[this.state.room.timeline.length - 1].event.content.msgtype === 'm.audio' && 'صوت'}
                    {this.state.room.timeline[this.state.room.timeline.length - 1].event.content.msgtype === 'm.video' && 'ویدئو'}
                    {this.state.room.timeline[this.state.room.timeline.length - 1].event.content.msgtype === 'm.application' && 'فایل'}
                    {this.state.room.timeline[this.state.room.timeline.length - 1].event.content.msgtype === 'm.text' && this.state.room.timeline[this.state.room.timeline.length - 1].event.content.body.substring(0, 30) +
                      (this.state.room.timeline[this.state.room.timeline.length - 1].event.content.body.length > 30 ? '...' : '')}
                  </p>

                  :
                  null
              }
              {
                this.state.room.timeline.length > 0 && this.state.room.timeline[this.state.room.timeline.length - 1].event.type === 'm.room.member' &&
                this.state.room.timeline[this.state.room.timeline.length - 1].event.membership === 'join' &&
                this.state.room.timeline[this.state.room.timeline.length - 1].getContent().displayname.includes('_') &&
                <p className='rtl' style={{ lineHeight: '20px', maxHeight: '20px', overflow: 'hidden' }}>
                  {Utils.roomMemberDisplayName(this.state.room.timeline[this.state.room.timeline.length - 1].sender)} به گفتگو پیوست
                </p>
              }
            </div>
            {this.state.room.getUnreadNotificationCount() ? <p className='notification-count'>{this.state.room.getUnreadNotificationCount()}</p> : null}
          </div>

        </div>

      </Link>
    )
  }
}
export default RoomListItem
